import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, buildParams, XmStore } from 'core/services';
import { planEligibilityDetails } from './models';
import { StoreAction } from 'store/actions';
import { targetPlanSwitchDetails } from './models/target-plan-switch';
import { PlanSwitchOrderReview } from './models/order-review';

@Injectable()
export class PlanEligibilityApi {
    public static planEligibility(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<planEligibilityDetails> {
        return http.get('/xm/plan/eligibility', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => planEligibilityDetails.create<planEligibilityDetails>(response))
        );
    }

    public static planEightEligibility(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<planEligibilityDetails> {
        return http.get('/xm/plan8/eligibility', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => planEligibilityDetails.create<planEligibilityDetails>(response))
        );
    }

    public static cbmPlanEligibility(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<planEligibilityDetails> {
        return http.get('/xm/t1/eligibility', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => planEligibilityDetails.create<planEligibilityDetails>(response))
        );
    }

    public static targetPlan8Switch(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<targetPlanSwitchDetails> {
        return http.get(`/xm/plan8/${params.planName}/switch`, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => targetPlanSwitchDetails.create<targetPlanSwitchDetails>(response))
        );
    }

    public static targetPlanSwitchCbm(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<targetPlanSwitchDetails> {
        return http.get(`/xm/t1/targetPlan/${params.planName}/switch`, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => targetPlanSwitchDetails.create<targetPlanSwitchDetails>(response))
        );
    }

    public static targetPlanUnlSwitch(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<targetPlanSwitchDetails> {
        return http.get('/xm/targetPlan/UNL/switch', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => targetPlanSwitchDetails.create<targetPlanSwitchDetails>(response))
        );
    }

    public static targetPlanBtgSwitch(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<targetPlanSwitchDetails> {
        return http.get('/xm/targetPlan/BTG/switch', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => targetPlanSwitchDetails.create<targetPlanSwitchDetails>(response))
        );
    }

    public static targetPlanUnlLegacySwitch(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<targetPlanSwitchDetails> {
        return http.get('/xm/targetPlan/legacy/UNL/switch', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => targetPlanSwitchDetails.create<targetPlanSwitchDetails>(response))
        );
    }

    public static targetPlanBtgLegacySwitch(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<targetPlanSwitchDetails> {
        return http.get('/xm/targetPlan/legacy/BTG/switch', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: buildParams({ lineIdKey: params.lineId })
        }).pipe(
            map((response: ApiResponse) => targetPlanSwitchDetails.create<targetPlanSwitchDetails>(response))
        );
    }

    public static postOrderReview(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<PlanSwitchOrderReview> {
        const { is_downgrade, ...bodyParams }: ApiParams = params;

        return http.post('/xm/billpreview/planSwitch', bodyParams, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: { ...(is_downgrade && { is_downgrade: true })}
        }).pipe(
            map((response: PlanSwitchOrderReview) => PlanSwitchOrderReview.create<PlanSwitchOrderReview>(response))
        );
    }

}
ModelBase.fetchMapping[StoreAction.GET_PLAN_ELIGIBILITY] = PlanEligibilityApi.planEligibility;
ModelBase.fetchMapping[StoreAction.GET_PLAN_EIGHT_ELIGIBILITY] = PlanEligibilityApi.planEightEligibility;
ModelBase.fetchMapping[StoreAction.GET_TARGET_PLAN_8_SWITCH] = PlanEligibilityApi.targetPlan8Switch;
ModelBase.fetchMapping[StoreAction.GET_TARGET_PLAN_SWITCH_CBM] = PlanEligibilityApi.targetPlanSwitchCbm;
ModelBase.fetchMapping[StoreAction.GET_CBM_PLAN_ELIGIBILITY] = PlanEligibilityApi.cbmPlanEligibility;
ModelBase.fetchMapping[StoreAction.GET_TARGET_PLAN_UNL_SWITCH] = PlanEligibilityApi.targetPlanUnlSwitch;
ModelBase.fetchMapping[StoreAction.GET_TARGET_PLAN_BTG_SWITCH] = PlanEligibilityApi.targetPlanBtgSwitch;
ModelBase.fetchMapping[StoreAction.GET_TARGET_PLAN_LEGACY_UNL_SWITCH] = PlanEligibilityApi.targetPlanUnlLegacySwitch;
ModelBase.fetchMapping[StoreAction.GET_TARGET_PLAN_LEGACY_BTG_SWITCH] = PlanEligibilityApi.targetPlanBtgLegacySwitch;
ModelBase.persistMapping[StoreAction.POST_PLAN_SWITCH_ORDER_REVIEW] = PlanEligibilityApi.postOrderReview;
